/*
  VAIROK · casilla de oferta de la ficha (snippets/vk-lite-offer.liquid). Sustituye a Candy Rack (04/10/2026).
  Con la casilla marcada, al enviar el formulario de compra (botón de la ficha o barra fija, que pulsa ese botón):
  1. /cart/add.js con items: el producto de la ficha (con su cantidad y propiedades) y el ofrecido, en una llamada.
     Si falla por el ofrecido (p. ej. se acaba de agotar), añade solo el producto de la ficha.
  2. /cart/update.js con discount = códigos que ya tenía el carrito + el del bloque (sin repetir) y las secciones del
     carrito, para pintar el cajón ya con el descuento.
  3. Pinta el cajón con el mismo método del tema (product-form.renderContents) y lo abre.
  Sin la casilla marcada, no hace nada: sigue el flujo normal del tema.
*/
(function () {
  'use strict';
  if (window.__vkOfferInit) return;
  window.__vkOfferInit = true;

  var SECTIONS = ['main-cart', 'cart-drawer', 'cart-bubble'];

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }
  function addUrl() {
    var u = window.theme && window.theme.routes && window.theme.routes.cart_add_url;
    return (u || root() + 'cart/add') + '.js';
  }
  function postJSON(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json().then(function (j) { return { ok: r.ok, data: j }; }); });
  }

  function mainItem(form) {
    var fd = new FormData(form);
    var item = { id: Number(fd.get('id')), quantity: Math.max(1, parseInt(fd.get('quantity'), 10) || 1) };
    var props = {};
    fd.forEach(function (value, key) {
      var m = /^properties\[(.+)\]$/.exec(key);
      if (m && typeof value === 'string' && value !== '') props[m[1]] = value;
    });
    if (Object.keys(props).length) item.properties = props;
    return item;
  }

  function setLoading(on) {
    document.querySelectorAll('.single-add-to-cart-button').forEach(function (b) {
      b.classList.toggle('loading', on);
      if (on) b.setAttribute('aria-disabled', 'true');
      else b.removeAttribute('aria-disabled');
    });
  }

  // Ojo: el formulario tiene un campo name="id": form.id devuelve ese campo, no el atributo.
  function formId(form) {
    return form.getAttribute('id') || '';
  }

  function productFormFor(form) {
    var section = formId(form).replace(/^product-form-/, '');
    return document.querySelector('product-form[data-section="' + section + '"]:not([data-sticky])');
  }

  function render(form, state) {
    var pf = productFormFor(form);
    if (pf && typeof pf.renderContents === 'function' && state && state.sections) {
      pf.renderContents(state);
    } else {
      window.location.href = root() + 'cart';
    }
  }

  function showError(form, message) {
    var pf = productFormFor(form);
    if (pf && typeof pf.handleErrorMessage === 'function') pf.handleErrorMessage(message);
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('form[data-type="add-to-cart-form"]')) return;
    var wrap = document.querySelector('[data-vk-offer][data-form-id="' + formId(form) + '"]');
    if (!wrap) return;
    var picked = Array.prototype.filter.call(wrap.querySelectorAll('[data-vk-offer-item]'), function (i) { return i.checked; });
    if (!picked.length) return;

    // Nos quedamos con el envío: el manejador del tema (en el formulario) no llega a ejecutarse.
    event.preventDefault();
    event.stopImmediatePropagation();

    var code = (wrap.getAttribute('data-code') || '').trim();
    var main = mainItem(form);
    var items = [main].concat(picked.map(function (i) {
      return { id: Number(i.value), quantity: 1, properties: { _vairok_offer: code || 'offer' } };
    }));
    var withOffer = true;

    setLoading(true);
    showError(form, false);

    postJSON(addUrl(), { items: items })
      .then(function (res) {
        if (res.ok) return res;
        // El ofrecido ya no se puede añadir: solo el producto de la ficha, sin código.
        withOffer = false;
        return postJSON(addUrl(), { items: [main] });
      })
      .then(function (res) {
        if (!res.ok) {
          showError(form, res.data && (res.data.description || res.data.message));
          throw new Error('add');
        }
        if (typeof window.dispatchCustomEvent === 'function') {
          window.dispatchCustomEvent('cart:item-added', { product: res.data.items ? res.data.items[0] : res.data });
        }
        return fetch(root() + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        var codes = (cart.discount_codes || []).map(function (d) { return d.code; }).filter(Boolean);
        if (withOffer && code && codes.map(function (c) { return c.toUpperCase(); }).indexOf(code.toUpperCase()) === -1) codes.push(code);
        var body = { sections: SECTIONS, sections_url: window.location.pathname };
        if (withOffer && code) body.discount = codes.join(',');
        return postJSON(root() + 'cart/update.js', body);
      })
      .then(function (res) {
        render(form, res.data);
      })
      .catch(function (e) {
        if (!e || e.message !== 'add') console.error(e);
      })
      .then(function () {
        setLoading(false);
      });
  }, true);
})();
